import { injectable } from "inversify";
import { AppService, Types } from "../../../App/Services/AppService";
import { StaticDataTypes } from "../../../Maintenance/StaticData/StaticDataTypes";
import { Catalogue } from "@singularsystems/neo-react-services"
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles";
import DataCache from "../../../Maintenance/StaticData/StaticDataCache";
import { IGeneralApiClient } from "../../../Common/ApiClients/GeneralApiClient";

@injectable()
export default class CatalogueEditService extends Catalogue.CatalogueEditService<DataCache, IGeneralApiClient> {

    constructor() {
        super(
            AppService.get(StaticDataTypes.Services.StaticDataCache),
            AppService.get(Types.ApiClients.GeneralApiClient)
        )

        this.makeObservable();
    }

    protected defaultEditRole() { 
        return Roles.CatalogueRoles.Edit;
    }
}